/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A set of colours with a fixed relationship on the colour wheel — complementary, analogous, triadic and so on — that tend to look good together.`)
};

const es_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un conjunto de colores con una relación fija en el círculo cromático — complementaria, análoga, triádica, etc. — que suelen quedar bien juntos.`)
};

const de_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Gruppe von Farben mit einer festen Beziehung auf dem Farbkreis — komplementär, analog, triadisch und so weiter —, die tendenziell gut zusammenpassen.`)
};

const nl_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een set kleuren met een vaste relatie op de kleurencirkel — complementair, analoog, triadisch enzovoort — die meestal goed samengaan.`)
};

const fr_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ensemble de couleurs avec une relation fixe sur le cercle chromatique — complémentaire, analogue, triadique, etc. — qui ont tendance à bien s'accorder.`)
};

const it_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un insieme di colori con una relazione fissa sulla ruota dei colori — complementare, analoga, triadica e così via — che tendono a stare bene insieme.`)
};

const pt_br2_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um conjunto de cores com uma relação fixa no círculo cromático — complementar, análoga, tríade e assim por diante — que costumam combinar bem entre si.`)
};

const pt_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um conjunto de cores com uma relação fixa no círculo cromático — complementar, análoga, triádica, entre outras — que costumam combinar bem.`)
};

const ja_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`補色、類似色、トライアドなど、色相環上で一定の関係を持つ色の組み合わせのことで、互いに調和しやすいとされています。`)
};

const zh_cp_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一组在色轮上具有固定关系的颜色——互补色、邻近色、三分色等——它们搭配在一起往往效果不错。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq_a1", locale)
	if (locale === "en") return en_cp_faq_a1(inputs)
	if (locale === "es") return es_cp_faq_a1(inputs)
	if (locale === "de") return de_cp_faq_a1(inputs)
	if (locale === "nl") return nl_cp_faq_a1(inputs)
	if (locale === "fr") return fr_cp_faq_a1(inputs)
	if (locale === "it") return it_cp_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq_a1(inputs)
	if (locale === "pt") return pt_cp_faq_a1(inputs)
	if (locale === "ja") return ja_cp_faq_a1(inputs)
	return zh_cp_faq_a1(inputs)
};